export default __webpack_public_path__ + "static/media/cedenar_logo.46ac8e56.png";